<button class="place_card" [ngClass]="{'selected-place_card': isSelected, 'place_card': !isSelected}"
    (click)="confirmDepartment()">
    <p class="title">{{puntoRitiro.Nome}}</p>
    <p class="subtitle">
        {{puntoRitiro.Files[0].LuogoReparto}} {{puntoRitiro.Files[0].CAP}} {{puntoRitiro.Files[0].Citta}}
        {{puntoRitiro.Files[0].Nazione}}
    </p>
</button>